{
  "enroll": "Enroll",
  "message": "Multi-factor authentication (MFA) adds an extra layer of security to your account. You will be required to provide a second form of verification in addition to your password when logging in.",
  "skip": "Skip for Now",
  "title": "Multi-Factor Authentication"
}
